import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { CreatePollRequest, UpdatePollRequest, ViewPollResultsRequest } from './poll.types';

export const requestCreatePoll = createAction<SagaPayload<CreatePollRequest>['payload']>('request/createPoll');

export const requestUpdatePoll = createAction<SagaPayload<UpdatePollRequest>['payload']>('request/updatePoll');

export const requestViewPollResults =
  createAction<SagaPayload<ViewPollResultsRequest>['payload']>('request/viewPollResults');
